import { render } from "./GroupScreen.vue?vue&type=template&id=7d075c1f"
import script from "./GroupScreen.vue?vue&type=script&lang=js"
export * from "./GroupScreen.vue?vue&type=script&lang=js"

import "./GroupScreen.vue?vue&type=style&index=0&id=7d075c1f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__